import React from "react";
import missionImg from "../../assets/images/mission.jpeg";

const MissionSection = () => {
  return (
    <div className={`py-12 sm:py-20 container mx-auto px-4`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div>
          <img
            className="rounded-bra-100 object-cover"
            src={missionImg}
            alt="img"
          />
        </div>
        <div className="flex justify-center items-center">
          <div>
            <h2 className="text-primary font-bold text-xl lg:text-4xl md:text-2xl m-0 break-words uppercase tracking-widest">
              Our Mission & Vision
            </h2>
            <h3 className="pt-2 text-gray-900 text-xl lg:text-3xl md:text-2xl font-bold m-0 break-words">
              Mission
            </h3>
            <p>
              To empower underprivileged individuals through education,
              financial aid, and community support, enabling them to achieve
              their dreams and contribute to a better society.
            </p>
            <h3 className="pt-2 text-gray-900 text-xl lg:text-3xl md:text-2xl font-bold m-0 break-words">
              Vission
            </h3>
            <p>
              To create a world where financial limitations are no barrier to
              education and opportunities, fostering a brighter and more
              inclusive future for all.
            </p>
            {/* <button className="mt-10 rounded-3xl py-2 px-6 text-base font-bold tracking-0.5 transition-all duration-0.5 text-white hover:text-primary border-2 border-primary bg-primary hover:bg-transparent">
              Learn More
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
